// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8152aa52","732":"77482453","952":"710e8549","977":"bf29fa28"}[chunkId] + ".chunk.js";
};